import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from '../../Context'
import { AuthContextApi } from '../../Context/api'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import './index.css'
import {
    PlusIcon,
    TruckIcon,
    UserIcon,
    TagIcon,
    ServerIcon,
    WrenchScrewdriverIcon,
    Cog6ToothIcon
} from '@heroicons/react/24/outline'

const Cadastros = () => {
    const { states, setters } = useContext(AuthContext)
    const { getEstatisticasMarcas, getEstatisticasEquipamentos, getEstatisticasEntidades, getCamposPersonalizados } = useContext(AuthContextApi)
    const navigate = useNavigate()

    // Estados para campos personalizados
    const [customFields, setCustomFields] = useState({
        nome: '',
        descricao: '',
        tipo: 'texto',
        obrigatorio: false
    })
    const [showCustomFields, setShowCustomFields] = useState(false)

    // useEffect para carregar estatísticas reais
    useEffect(() => {
        getEstatisticasMarcas()
        getEstatisticasEquipamentos()
        getEstatisticasEntidades()
        getCamposPersonalizados()
    }, [])

    // useEffect para limpeza ao desmontar
    useEffect(() => {
        return () => {
            setters.setPage(1)
        }
    }, [])

    // Função para navegar para marca
    const navigateToMarca = () => {
        navigate('/cadastros/marca')
    }

    // Função para navegar para equipamento
    const navigateToCamposPersonalizados = () => {
        navigate('/cadastros/campos-personalizados')
    }

    const navigateToEquipamento = () => {
        navigate('/cadastros/equipamento')
    }

    // Função para navegar para clientes
    const navigateToClientes = () => {
        navigate('/cadastros/clientes')
    }

    // Função para navegar para fornecedores
    const navigateToFornecedores = () => {
        navigate('/cadastros/fornecedores')
    }

    // Função para navegar para usuários
    const navigateToUsuarios = () => {
        navigate('/cadastros/usuarios')
    }

    // Função para navegar para painel de campos personalizados
    const navigateToCustomFields = () => {
        // Implementar navegação para painel de campos personalizados
        toast.info('Painel de campos personalizados em desenvolvimento')
    }

    // Função para adicionar campo personalizado
    const addCustomField = () => {
        if (!customFields.nome.trim()) {
            toast.error('Nome do campo é obrigatório')
            return
        }

        // Implementar lógica para adicionar campo personalizado
        toast.success('Campo personalizado adicionado com sucesso!')
        setCustomFields({
            nome: '',
            descricao: '',
            tipo: 'texto',
            obrigatorio: false
        })
        setShowCustomFields(false)
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50/30">
            {/* Header Artístico */}
            <div className="relative bg-gradient-to-br from-purple-50/80 via-white/80 to-indigo-50/80 backdrop-blur-sm border-b border-gradient-to-r from-purple-200/50 to-indigo-200/50 sticky top-0 z-10">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 to-indigo-500/5"></div>
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-purple-400/10 to-indigo-400/10 rounded-full -translate-y-16 translate-x-16"></div>
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                        <div>
                            <h1 className="text-4xl font-bold bg-gradient-to-r from-gray-900 via-purple-800 to-indigo-800 bg-clip-text text-transparent">
                                Gestão de Cadastros
                            </h1>
                            <p className="mt-3 text-lg text-gray-600 font-medium">
                                Painel central para gerenciar marcas e estruturas
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Conteúdo Principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

                {/* Cards de Navegação - Design Artístico */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                    {/* Card Marcas */}
                    <div
                        onClick={navigateToMarca}
                        className="relative bg-gradient-to-br from-purple-50 via-white to-purple-50/30 backdrop-blur-sm rounded-3xl shadow-lg border border-purple-100/50 hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden cursor-pointer group"
                    >
                        <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 to-purple-500/5"></div>
                        <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-purple-400/10 to-purple-400/10 rounded-full -translate-y-12 translate-x-12"></div>

                        <div className="relative p-6">
                            {/* Header do Card */}
                            <div className="mb-4">
                                <div className="flex items-center mb-3">
                                    <div className="p-3 rounded-2xl bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 shadow-lg mr-4">
                                        <TagIcon className="w-6 h-6 text-white" />
                                    </div>
                                    <div>
                                        <h2 className="text-xl font-bold bg-gradient-to-r from-gray-900 via-purple-800 to-purple-700 bg-clip-text text-transparent">
                                            Marcas
                                        </h2>
                                    </div>
                                </div>
                                <p className="text-sm text-gray-600">
                                    Gerencie as marcas dos produtos
                                </p>
                            </div>

                            {/* Estatísticas Rápidas */}
                            <div className="space-y-2 mb-4">
                                {states.dataEstatisticaMarcas && Array.isArray(states.dataEstatisticaMarcas) && states.dataEstatisticaMarcas.length > 0 && states.dataEstatisticaMarcas.slice(0, 2).map((card, index) => (
                                    <div key={card.title} className="bg-white/50 backdrop-blur-sm rounded-xl p-3 border border-purple-100/50">
                                        <div className="flex items-center justify-between">
                                            <div className="text-xs text-gray-600 truncate">{card.title}</div>
                                            <div className="text-lg font-bold text-purple-600">{card.value}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Ações Rápidas */}
                            <div className="flex space-x-2">
                                <button className="flex-1 group relative inline-flex items-center justify-center px-3 py-2 border border-purple-300 rounded-xl text-xs font-semibold text-purple-700 bg-gradient-to-r from-purple-50 to-purple-50 hover:from-purple-100 hover:to-purple-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-all duration-300 transform hover:scale-105">
                                    <div className="relative z-10 flex items-center">
                                        <PlusIcon className="w-3 h-3 mr-1 group-hover:scale-110 transition-transform duration-200" />
                                        <span>Nova</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Card Estruturas */}
                    <div
                        onClick={navigateToEquipamento}
                        className="relative bg-gradient-to-br from-indigo-50 via-white to-indigo-50/30 backdrop-blur-sm rounded-3xl shadow-lg border border-indigo-100/50 hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden cursor-pointer group"
                    >
                        <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-indigo-500/5"></div>
                        <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-indigo-400/10 to-indigo-400/10 rounded-full -translate-y-12 translate-x-12"></div>

                        <div className="relative p-6">
                            {/* Header do Card */}
                            <div className="mb-4">
                                <div className="flex items-center mb-3">
                                    <div className="p-3 rounded-2xl bg-gradient-to-r from-indigo-500 via-indigo-600 to-indigo-700 shadow-lg mr-4">
                                        <ServerIcon className="w-6 h-6 text-white" />
                                    </div>
                                    <div>
                                        <h2 className="text-xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-indigo-700 bg-clip-text text-transparent">
                                            Estruturas
                                        </h2>
                                    </div>
                                </div>
                                <p className="text-sm text-gray-600">
                                    Gerencie equipamentos e formatos
                                </p>
                            </div>

                            {/* Estatísticas Rápidas */}
                            <div className="space-y-2 mb-4">
                                {states.dataEstatisticaEquipamentos && Array.isArray(states.dataEstatisticaEquipamentos) && states.dataEstatisticaEquipamentos.length > 0 && states.dataEstatisticaEquipamentos.slice(0, 2).map((card, index) => (
                                    <div key={card.title} className="bg-white/50 backdrop-blur-sm rounded-xl p-3 border border-indigo-100/50">
                                        <div className="flex items-center justify-between">
                                            <div className="text-xs text-gray-600 truncate">{card.title}</div>
                                            <div className="text-lg font-bold text-indigo-600">{card.value}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Ações Rápidas */}
                            <div className="flex space-x-2">
                                <button className="flex-1 group relative inline-flex items-center justify-center px-3 py-2 border border-indigo-300 rounded-xl text-xs font-semibold text-indigo-700 bg-gradient-to-r from-indigo-50 to-indigo-50 hover:from-indigo-100 hover:to-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300 transform hover:scale-105">
                                    <div className="relative z-10 flex items-center">
                                        <PlusIcon className="w-3 h-3 mr-1 group-hover:scale-110 transition-transform duration-200" />
                                        <span>Novo</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Card Clientes */}
                    <div
                        onClick={navigateToClientes}
                        className="relative bg-gradient-to-br from-blue-50 via-white to-blue-50/30 backdrop-blur-sm rounded-3xl shadow-lg border border-blue-100/50 hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden cursor-pointer group"
                    >
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-blue-500/5"></div>
                        <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-blue-400/10 to-blue-400/10 rounded-full -translate-y-12 translate-x-12"></div>

                        <div className="relative p-6">
                            {/* Header do Card */}
                            <div className="mb-4">
                                <div className="flex items-center mb-3">
                                    <div className="p-3 rounded-2xl bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 shadow-lg mr-4">
                                        <UserIcon className="w-6 h-6 text-white" />
                                    </div>
                                    <div>
                                        <h2 className="text-xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-blue-700 bg-clip-text text-transparent">
                                            Clientes
                                        </h2>
                                    </div>
                                </div>
                                <p className="text-sm text-gray-600">
                                    Gerencie os clientes do sistema
                                </p>
                            </div>

                            {/* Estatísticas Rápidas */}
                            <div className="space-y-2 mb-4">
                                {states.dataEstatisticaEntidades && Array.isArray(states.dataEstatisticaEntidades) && states.dataEstatisticaEntidades.length > 0 && states.dataEstatisticaEntidades
                                    .filter(card => card.title.includes('Cliente'))
                                    .slice(0, 2)
                                    .map((card, index) => (
                                        <div key={card.title} className="bg-white/50 backdrop-blur-sm rounded-xl p-3 border border-blue-100/50">
                                            <div className="flex items-center justify-between">
                                                <div className="text-xs text-gray-600 truncate">{card.title}</div>
                                                <div className="text-lg font-bold text-blue-600">{card.value}</div>
                                            </div>
                                        </div>
                                    ))}
                            </div>

                            {/* Ações Rápidas */}
                            <div className="flex space-x-2">
                                <button className="flex-1 group relative inline-flex items-center justify-center px-3 py-2 border border-blue-300 rounded-xl text-xs font-semibold text-blue-700 bg-gradient-to-r from-blue-50 to-blue-50 hover:from-blue-100 hover:to-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 transform hover:scale-105">
                                    <div className="relative z-10 flex items-center">
                                        <PlusIcon className="w-3 h-3 mr-1 group-hover:scale-110 transition-transform duration-200" />
                                        <span>Novo</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Card Fornecedores */}
                    <div
                        onClick={navigateToFornecedores}
                        className="relative bg-gradient-to-br from-green-50 via-white to-green-50/30 backdrop-blur-sm rounded-3xl shadow-lg border border-green-100/50 hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden cursor-pointer group"
                    >
                        <div className="absolute inset-0 bg-gradient-to-br from-green-500/5 to-green-500/5"></div>
                        <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-green-400/10 to-green-400/10 rounded-full -translate-y-12 translate-x-12"></div>

                        <div className="relative p-6">
                            {/* Header do Card */}
                            <div className="mb-4">
                                <div className="flex items-center mb-3">
                                    <div className="p-3 rounded-2xl bg-gradient-to-r from-green-500 via-green-600 to-green-700 shadow-lg mr-4">
                                        <TruckIcon className="w-6 h-6 text-white" />
                                    </div>
                                    <div>
                                        <h2 className="text-xl font-bold bg-gradient-to-r from-gray-900 via-green-800 to-green-700 bg-clip-text text-transparent">
                                            Fornecedores
                                        </h2>
                                    </div>
                                </div>
                                <p className="text-sm text-gray-600">
                                    Gerencie os fornecedores do sistema
                                </p>
                            </div>

                            {/* Estatísticas Rápidas */}
                            <div className="space-y-2 mb-4">
                                {states.dataEstatisticaEntidades && Array.isArray(states.dataEstatisticaEntidades) && states.dataEstatisticaEntidades.length > 0 && states.dataEstatisticaEntidades
                                    .filter(card => card.title.includes('Fornecedor'))
                                    .slice(0, 2)
                                    .map((card, index) => (
                                        <div key={card.title} className="bg-white/50 backdrop-blur-sm rounded-xl p-3 border border-green-100/50">
                                            <div className="flex items-center justify-between">
                                                <div className="text-xs text-gray-600 truncate">{card.title}</div>
                                                <div className="text-lg font-bold text-green-600">{card.value}</div>
                                            </div>
                                        </div>
                                    ))}
                            </div>

                            {/* Ações Rápidas */}
                            <div className="flex space-x-2">
                                <button className="flex-1 group relative inline-flex items-center justify-center px-3 py-2 border border-green-300 rounded-xl text-xs font-semibold text-green-700 bg-gradient-to-r from-green-50 to-green-50 hover:from-green-100 hover:to-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-300 transform hover:scale-105">
                                    <div className="relative z-10 flex items-center">
                                        <PlusIcon className="w-3 h-3 mr-1 group-hover:scale-110 transition-transform duration-200" />
                                        <span>Novo</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>

                    {
                        (localStorage.getItem('permisssion') === "ADMIN") && (
                            <>


                                {/* Card Usuários */}
                                <div
                                    onClick={navigateToUsuarios}
                                    className="relative bg-gradient-to-br from-orange-50 via-white to-orange-50/30 backdrop-blur-sm rounded-3xl shadow-lg border border-orange-100/50 hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden cursor-pointer group"
                                >
                                    <div className="absolute inset-0 bg-gradient-to-br from-orange-500/5 to-orange-500/5"></div>
                                    <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-orange-400/10 to-orange-400/10 rounded-full -translate-y-12 translate-x-12"></div>

                                    <div className="relative p-6">
                                        {/* Header do Card */}
                                        <div className="mb-4">
                                            <div className="flex items-center mb-3">
                                                <div className="p-3 rounded-2xl bg-gradient-to-r from-orange-500 via-orange-600 to-orange-700 shadow-lg mr-4">
                                                    <UserIcon className="w-6 h-6 text-white" />
                                                </div>
                                                <div>
                                                    <h2 className="text-xl font-bold bg-gradient-to-r from-gray-900 via-orange-800 to-orange-700 bg-clip-text text-transparent">
                                                        Usuários
                                                    </h2>
                                                </div>
                                            </div>
                                            <p className="text-sm text-gray-600">
                                                Gerencie os usuários do sistema
                                            </p>
                                        </div>

                                        {/* Estatísticas Rápidas */}
                                        <div className="space-y-2 mb-4">
                                            <div className="bg-white/50 backdrop-blur-sm rounded-xl p-3 border border-orange-100/50">
                                                <div className="flex items-center justify-between">
                                                    <div className="text-xs text-gray-600 truncate">Usuários ativos</div>
                                                    <div className="text-lg font-bold text-orange-600">-</div>
                                                </div>
                                            </div>
                                            <div className="bg-white/50 backdrop-blur-sm rounded-xl p-3 border border-orange-100/50">
                                                <div className="flex items-center justify-between">
                                                    <div className="text-xs text-gray-600 truncate">Total de usuários</div>
                                                    <div className="text-lg font-bold text-orange-600">-</div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Ações Rápidas */}
                                        <div className="flex space-x-2">
                                            <button className="flex-1 group relative inline-flex items-center justify-center px-3 py-2 border border-orange-300 rounded-xl text-xs font-semibold text-orange-700 bg-gradient-to-r from-orange-50 to-orange-50 hover:from-orange-100 hover:to-orange-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-all duration-300 transform hover:scale-105">
                                                <div className="relative z-10 flex items-center">
                                                    <PlusIcon className="w-3 h-3 mr-1 group-hover:scale-110 transition-transform duration-200" />
                                                    <span>Novo</span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    onClick={navigateToCamposPersonalizados}
                                    className="relative bg-gradient-to-br from-gray-50 via-white to-gray-50/30 backdrop-blur-sm rounded-3xl shadow-lg border border-gray-100/50 hover:shadow-xl transition-all duration-300 transform hover:scale-105 overflow-hidden cursor-pointer group"
                                >
                                    <div className="absolute inset-0 bg-gradient-to-br from-gray-500/5 to-gray-500/5"></div>
                                    <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-gray-400/10 to-gray-400/10 rounded-full -translate-y-12 translate-x-12"></div>

                                    <div className="relative p-6">
                                        {/* Header do Card */}
                                        <div className="mb-4">
                                            <div className="flex items-center mb-3">
                                                <div className="p-3 rounded-2xl bg-gradient-to-r from-gray-500 via-gray-600 to-gray-700 shadow-lg mr-4">
                                                    <Cog6ToothIcon className="w-6 h-6 text-white" />
                                                </div>
                                                <div>
                                                    <h2 className="text-xl font-bold bg-gradient-to-r from-gray-900 via-gray-800 to-gray-700 bg-clip-text text-transparent">
                                                        Campos
                                                    </h2>
                                                </div>
                                            </div>
                                            <p className="text-sm text-gray-600">
                                                Configure campos personalizados
                                            </p>
                                        </div>

                                        {/* Estatísticas Rápidas */}
                                        <div className="space-y-2 mb-4">
                                            <div className="bg-white/50 backdrop-blur-sm rounded-xl p-3 border border-gray-100/50">
                                                <div className="flex items-center justify-between">
                                                    <div className="text-xs text-gray-600 truncate">Campos personalizados</div>
                                                    <div className="text-lg font-bold text-gray-600">{states.dataCamposPersonalizados.length}</div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Ações Rápidas */}
                                        <div className="flex space-x-2 mt-[43%]">
                                            <button className="flex-1 group relative inline-flex items-center justify-center px-3 py-2 border border-gray-300 rounded-xl text-xs font-semibold text-gray-700 bg-gradient-to-r from-gray-50 to-gray-50 hover:from-gray-100 hover:to-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all duration-300 transform hover:scale-105">
                                                <div className="relative z-10 flex items-center">
                                                    <WrenchScrewdriverIcon className="w-3 h-3 mr-1 group-hover:scale-110 transition-transform duration-200" />
                                                    <span>Configurar</span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>


            </div>
        </div>
    )
}

export default Cadastros